import { useMemo } from 'react';
import { useAssetsConfig } from 'store/app/appStore';
import { useIsHeaderCollapsed, useCampaignActions, useCampaignType } from '../../store/campaignsStore';
import { useCampaignTypeContext } from '../../store/context/CampaignTypeContext';

export const useCampaignCollapsibleState = () => {
  const { assetsHost, assetsHash } = useAssetsConfig();
  // Same resolution as useIsHeaderCollapsed: the section's context type, so the
  // arrow toggles the correct per-type collapse flag without callers passing it.
  const contextType = useCampaignTypeContext();
  const fallbackType = useCampaignType();
  const campaignType = contextType ?? fallbackType;
  const isCollapsed = useIsHeaderCollapsed();
  const { toggleHeaderCollapsed } = useCampaignActions();

  const arrow = useMemo(() => {
    if (!assetsHost) {
      return '';
    }

    const normalizedHost = assetsHost.replace(/\/$/, '');
    const hash = assetsHash?.trim();
    const rootPath = hash ? `/${hash}/assets/portal` : '/assets/portal';
    const url = `${normalizedHost}${rootPath}/campaigns/icons/arrow.svg`;

    return hash ? `${url}?hash=${hash}` : url;
  }, [assetsHost, assetsHash]);

  const handleArrowClick = () => {
    toggleHeaderCollapsed(campaignType);
  };

  return {
    isCollapsed,
    arrow,
    handleArrowClick,
  };
};
